module.exports = __webpack_public_path__ + "7e4b29ba/img/revit-icon.5ff0d581.svg";